module.exports = __webpack_public_path__ + "img/main_bottopm_top1.59598050.png";